import * as React from 'react';
import { Card, CardContent } from '../../../../../../components/ui/Card';
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../../../../../../lib/locale';
import { formatMoney } from '@repo/utils';
import type { BidDetail } from '../../../../../../features/auctions/types';

interface AuctionBidLogProps {
  bids: BidDetail[];
  winnerSubscriptionId: string | null;
}

function formatPaise(paise: number): string {
  return formatMoney(paise, { currency: DEFAULT_CURRENCY, locale: DEFAULT_LOCALE });
}

function BidTable({ bids, winnerSubscriptionId }: { bids: BidDetail[]; winnerSubscriptionId: string | null }) {
  return (
    <div className="bg-surface-1 border border-border rounded-xl overflow-hidden shadow-sm">
      <table className="w-full border-collapse text-left text-sm">
        <thead className="bg-surface-2 text-text-secondary font-semibold uppercase tracking-wider text-xs border-b border-border">
          <tr>
            <th className="p-4">Subscriber</th>
            <th className="p-4">Discount Bid</th>
            <th className="p-4">Time</th>
            <th className="p-4">Channel</th>
            <th className="p-4">Winner</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border text-text-primary">
          {bids.length === 0 ? (
            <tr>
              <td colSpan={5} className="p-8 text-center text-text-muted">No bids yet</td>
            </tr>
          ) : (
            bids.map((bid, index) => {
              const isWinner = bid.subscriberId === winnerSubscriptionId || bid.isWinner;
              return (
                <tr key={bid.subscriberId + bid.bidAt + index} className={`hover:bg-surface-2 transition-colors ${isWinner ? 'bg-success-bg/40' : ''}`}>
                  <td className="p-4 font-mono text-xs text-text-primary">{bid.subscriberId.slice(0, 8)}…</td>
                  <td className="p-4 font-medium text-text-primary">{formatPaise(bid.bidDiscount)}</td>
                  <td className="p-4 text-text-secondary">{new Date(bid.bidAt).toLocaleTimeString('en-IN')}</td>
                  <td className="p-4 text-text-secondary">{bid.bidChannel}</td>
                  <td className="p-4">
                    {isWinner ? (
                      <span className="px-2 py-0.5 bg-success-bg text-success-text rounded-full text-xs font-medium">Winner</span>
                    ) : null}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}

export function AuctionBidLog({ bids, winnerSubscriptionId }: AuctionBidLogProps) {
  return (
    <Card>
      <CardContent className="p-5">
        <h2 className="text-base font-semibold text-text-primary mb-4">Bids ({bids.length})</h2>
        <BidTable bids={bids} winnerSubscriptionId={winnerSubscriptionId} />
      </CardContent>
    </Card>
  );
}
